import { QueryFactory } from '@lmt/shared-types';
import { Loading } from '@lmt/unicorn-shared/app/components/common/Loading';
import { Button } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { useGlobalForms } from '@lmt/unicorn-shared/app/components/global-forms/useGlobalForms';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import { useTabs } from '@lmt/unicorn-shared/app/features/navigation/operations';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC, useEffect, useState } from 'react';
import { MappingTable } from './components/MappingTable';

import styles from './GDTMappingPage.module.scss';

export const GDTMappingPage: FC = React.memo(function MappingPage() {
  const mappingId = pages.gdtMappingsWithId.useMatch()?.params?.mappingId;
  const tabs = useTabs();
  const i18next = useScopedTranslation('gdt.mapping');
  const forms = useGlobalForms();
  const { data: mappings, isLoading: isLoading } =
    QueryFactory.GDTMappingQuery.useGetAllQuery();

  const [activeMappingId, setActiveMappingId] = useState<
    number | undefined | null
  >(mappingId);
  useEffect(() => {
    if (mappings && mappings.length > 0 && !activeMappingId) {
      setActiveMappingId(mappings[0].id);
    }
  }, [activeMappingId, mappings]);

  useEffect(() => {
    if (activeMappingId) {
      tabs.changeTabPath(
        pages.gdtMappingsWithId.link({
          mappingId: activeMappingId,
        }),
        true,
      );
    }
  }, [activeMappingId]);

  if (!mappings) {
    return null;
  }
  return (
    <div className={styles.storedScrolling} data-test-id="gdt-mapping-page">
      <Loading title={i18next.t('loading')} loading={isLoading}>
        <div className={styles.table}>
          {mappings.length === 0 ? (
            <div>
              <Button
                onClick={() => forms.openGDTMappings()}
                title={i18next.t('add_new_mapping')}
              />
            </div>
          ) : null}
          {activeMappingId && <MappingTable mappingId={activeMappingId} />}
        </div>
      </Loading>
    </div>
  );
});
